import { CommonConnectionModel, ElasticsearchConnectionSchema, MongoConnectionScheme, RdbmsConnectionSchema } from '../../domain/connection/ConnectionDomains';
import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ConnectionActions } from '../actions/ConnectionActions';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';

export interface ConnectionState {
  connection: CommonConnectionModel;
  connectionSchema: DeploymentModel<ElasticsearchConnectionSchema | RdbmsConnectionSchema | MongoConnectionScheme> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: ConnectionState = {
  connection: ValueFactory.initializeConnection(),
  connectionSchema: { stage: 'DRAFT' } as DeploymentModel<ElasticsearchConnectionSchema | RdbmsConnectionSchema | MongoConnectionScheme>,
  isUpdate: false,
  isDirty: false,
};

export const connectionReducer = (state = initialState, action: ReduxBaseAction<any, ConnectionActions>) => {
  switch (action.type) {
    case 'CHANGE_CONNECTION':
      return { ...state, connection: action.payload, isDirty: true };
    case 'CHANGE_CONNECTION_SCHEMA':
      return { ...state, connectionSchema: action.payload };
    case 'CHANGE_CONNECTION_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_CONNECTION':
      return { ...state, connection: ValueFactory.initializeConnection(), isUpdate: false, connectionSchema: null, isDirty: false };
    case 'CHANGE_CONNECTION_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
